import React from "react"

import { Card } from "components/Subscriptions/elements"
import Title from "components/Subscription/Title"
import Plan from "components/Subscription/Plan"
import Payments from "components/Subscription/Payments"
import { SubscriptionType } from "types"

type Props = {
  item: SubscriptionType
}

const SubscriptionItem = ({ item }: Props) => {
  const { payments } = item

  return (
    <Card elevation={0} data-testid="subscription">
      <Title subscription={item} />
      <Plan subscription={item} />
      <Payments items={payments} />
    </Card>
  )
}

export default SubscriptionItem
